import { TimeBasedMenuVisibilitySetting } from 'models/Config'
import { api } from './index'

type OrderingConfig = {
  time_based_menu_visibility?: TimeBasedMenuVisibilitySetting
}

type OrderingConfigResponse = {
  ordering_config: OrderingConfig
}

// Endpoint names share the root api's single namespace; a duplicate
// injection is silently dropped in production (first one wins). locationsApi
// already owns `getOrderingConfig` for the per-location resource, hence the
// Merchant prefix.
export const orderingConfigApi = api.injectEndpoints({
  overrideExisting: false,
  endpoints: build => ({
    getMerchantOrderingConfig: build.query<OrderingConfigResponse, void>({
      query: () => 'ordering_config',
      providesTags: ['OrderingConfig'],
    }),
    updateMerchantOrderingConfig: build.mutation<
      OrderingConfigResponse,
      OrderingConfig
    >({
      query: config => ({
        url: 'ordering_config',
        method: 'PATCH',
        body: { ordering_config: config },
      }),
      invalidatesTags: ['OrderingConfig'],
    }),
  }),
})

export const {
  useGetMerchantOrderingConfigQuery,
  useUpdateMerchantOrderingConfigMutation,
} = orderingConfigApi
